import CaseNotesApiService from '../services/api/caseNotes';
import { enqueueNotification } from './notifications';

const FETCH_CASE_NOTES_REQUEST = 'FETCH_CASE_NOTES_REQUEST';
const FETCH_CASE_NOTES_SUCCESS = 'FETCH_CASE_NOTES_SUCCESS';
const APPEND_CASE_NOTES = 'APPEND_CASE_NOTES';

const ADD_CASE_NOTE_REQUEST = 'ADD_CASE_NOTE_REQUEST';
const ADD_CASE_NOTE_SUCCESS = 'ADD_CASE_NOTE_SUCCESS';
const ADD_CASE_NOTE_FAILED = 'ADD_CASE_NOTE_FAILED';

const ACKNOWLEDGE_CASE_NOTE_REQUEST = 'ACKNOWLEDGE_CASE_NOTE_REQUEST';
const ACKNOWLEDGE_CASE_NOTE_SUCCESS = 'ACKNOWLEDGE_CASE_NOTE_SUCCESS';
const ACKNOWLEDGE_CASE_NOTE_FAILED = 'ACKNOWLEDGE_CASE_NOTE_FAILED';

const RESET_CASE_NOTES = 'RESET_CASE_NOTES';

const initialState = {
  patientId: null,
  messages: [],
  fetching: false,
  sending: false,
  acknowledging: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET_CASE_NOTES:
      return initialState;
    case FETCH_CASE_NOTES_REQUEST:
      return {
        ...state,
        patientId: action.payload.patientId,
        messages: [],
        fetching: true
      };
    case FETCH_CASE_NOTES_SUCCESS:
      return {
        ...state,
        fetching: false,
        messages: action.payload.messages
      };
    case APPEND_CASE_NOTES: {
      const newMessages = action.payload.messages.filter(
        message => !state.messages.some(existingMessage => existingMessage.id === message.id)
      );
      return {
        ...state,
        messages: [...state.messages, ...newMessages]
      };
    }
    case ADD_CASE_NOTE_REQUEST:
      return {
        ...state,
        sending: true
      };
    case ADD_CASE_NOTE_SUCCESS:
    case ADD_CASE_NOTE_FAILED:
      return {
        ...state,
        sending: false
      };
    case ACKNOWLEDGE_CASE_NOTE_REQUEST:
      return {
        ...state,
        acknowledging: true
      };
    case ACKNOWLEDGE_CASE_NOTE_SUCCESS:
      return {
        ...state,
        acknowledging: false,
        messages: state.messages.map(message =>
          message.id === action.payload.id ? { ...message, acknowledged: true } : message
        )
      };
    case ACKNOWLEDGE_CASE_NOTE_FAILED:
      return {
        ...state,
        acknowledging: false
      };
    default:
      return state;
  }
};

export function fetchCaseNotes(patientId, onlyNew = false) {
  return (dispatch, getState) => {
    const state = getState();
    const sinceId = onlyNew
      ? state.caseNotes.messages[state.caseNotes.messages.length - 1]?.id
      : null;

    if (state.caseNotes.patientId && state.caseNotes.patientId !== patientId) {
      dispatch({
        type: RESET_CASE_NOTES
      });
    }

    const caseNotesApiService = new CaseNotesApiService();

    if (!sinceId) {
      dispatch({
        type: FETCH_CASE_NOTES_REQUEST,
        payload: { patientId }
      });
    }

    return caseNotesApiService
      .fetchCaseNotes(patientId, sinceId)
      .then(response => {
        if (sinceId) {
          dispatch({
            type: APPEND_CASE_NOTES,
            payload: { messages: response.data }
          });
        } else {
          dispatch({
            type: FETCH_CASE_NOTES_SUCCESS,
            payload: { messages: response.data }
          });
        }
      })
      .catch(error => {
        dispatch(enqueueNotification('error', error.message));
      });
  };
}

export function addCaseNote(patientId, message) {
  return dispatch => {
    const caseNotesApiService = new CaseNotesApiService();
    dispatch({
      type: ADD_CASE_NOTE_REQUEST
    });
    return caseNotesApiService
      .addCaseNote(patientId, message)
      .then(() => {
        dispatch({
          type: ADD_CASE_NOTE_SUCCESS
        });
        dispatch(fetchCaseNotes(patientId, true));
      })
      .catch(error => {
        dispatch({
          type: ADD_CASE_NOTE_FAILED
        });
        dispatch(enqueueNotification('error', error.message));
      });
  };
}

export function acknowledgeCaseNote(id) {
  return dispatch => {
    const caseNotesApiService = new CaseNotesApiService();
    dispatch({
      type: ACKNOWLEDGE_CASE_NOTE_REQUEST
    });
    return caseNotesApiService
      .acknowledge(id)
      .then(() => {
        dispatch({
          type: ACKNOWLEDGE_CASE_NOTE_SUCCESS,
          payload: { id }
        });
        dispatch(enqueueNotification('success', 'Case note acknowledged.'));
      })
      .catch(error => {
        dispatch({
          type: ACKNOWLEDGE_CASE_NOTE_FAILED
        });
        dispatch(enqueueNotification('error', error.message));
      });
  };
}
